import { getAdminMe } from "@/services/auth/adminAuthService";
import { createStore } from "vuex";

export const globalStore = createStore({
  state: () => {
    return {
      showMenu: false,
      loaded: false,
      admin: null,
    };
  },
  getters: {
    getIfMenuActive: (s) => s.showMenu,
    getAdmin: (state) => state.admin,
    getAdminLoaded: (state) => state.loaded,
  },
  mutations: {
    SET_ADMIN(state, admin) {
      state.admin = admin;
    },
    SET_ADMIN_LOADED(state, value) {
      state.loaded = value;
    },
  },
  actions: {
    async loadAdmin({ state, commit }) {
      if (state.loaded) return state.admin;

      try {
        const { data } = await getAdminMe();
        commit("SET_ADMIN", data.admin);
      } catch {
        commit("SET_ADMIN", null);
      }

      commit("SET_ADMIN_LOADED", true);
      return state.admin;
    },
  },
  modules: {},
});
